import { autoserialize } from 'cerialize';


export class FareReviewStatus {
  @autoserialize
  fareReviewStatus: string;

  @autoserialize
  executionPlatform: string;
}
